import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
    selector: 'app-input-toggle',
    templateUrl: './input-toggle.component.html',
    styleUrls: ['./input-toggle.component.scss'],
    standalone: false
})
export class InputToggleComponent {
  @Input() useIconToolTip;
  @Input() control;
  @Input() disabled: boolean = false;
  @Input() tooltip;
  @Input() disabledTooltip?: string;
  @Output() changeUpdate = new EventEmitter<any>();
  constructor(private cd: ChangeDetectorRef) {}

  toggle($event: Event) {
    $event.stopPropagation();
    $event.stopImmediatePropagation();
    $event.preventDefault();

    if (this.disabled || this.control?.disabled) {
      return;
    }

    if (this.control) {
      this.control.setValue(!this.control.value);
      this.control.markAsTouched();
      this.control.markAsDirty();
    }

    this.changeUpdate.emit($event);
    this.cd.detectChanges();
  }
}
